export default [{
  label: 'AT&T',
  value: 'ATT',
}, {
  label: 'AT&T Home (tradional landline)',
  value: 'ATTHOME',
}, {
  label: 'Comcast',
  value: 'COMCAST',
}, {
  label: 'Fortel',
  value: 'FORTEL',
}, {
  label: 'Ooma',
  value: 'OOMA',
}, {
  label: 'Ring Central',
  value: 'RCT',
}];
